import { GetScoringStandardListReq } from '@standard/models/get-scoring-standard-list.model';
import { ScoringStandard } from '@standard/models/scoring-standard.model';
import standardRepository from '@standard/standard.module';
import { useQuery } from '@tanstack/react-query';
import { StandardListFilterSchema } from '../../models/standard-list-filter.model';

// #region Types
type ScoringStandardListQueryParameter =
  | Partial<GetScoringStandardListReq>
  | StandardListFilterSchema;
// #endregion

// #region Constants
export const SCORING_STANDARD_LIST_QUERY_KEY = 'scoring-standard-list';
// #endregion

export default function useScoringStandardListQuery({
  bunriId,
  facultyId,
  subjectId,
  universityId,
}: ScoringStandardListQueryParameter = {}) {
  // #region Computed Values
  const enabled = subjectId != null && universityId != null;
  // #endregion

  // #region Query
  const { data, isFetching } = useQuery<ScoringStandard[]>({
    enabled,
    queryFn: async ({ signal }) => {
      const response = await standardRepository.getScoringStandardList(
        {
          bunriId: bunriId?.toString(),
          facultyId: facultyId?.toString(),
          subjectId: subjectId?.toString() ?? '',
          universityId: universityId ?? '',
        },
        signal,
      );

      return response.body?.parts ?? [];
    },
    queryKey: [SCORING_STANDARD_LIST_QUERY_KEY, subjectId, universityId, bunriId, facultyId],
  });
  // #endregion

  return { data, enabled, isFetching };
}
